import { createContext } from "react";
import { refProps } from "../types/types";

export const refContext = createContext<refProps>({} as refProps);